import { motion } from 'framer-motion'

// material
import { Box, BoxProps } from '@mui/material'

//
import { varSmallClick, varMediumClick } from './variants'

// ----------------------------------------------------------------------

interface ButtonAnimateProps extends BoxProps {
  mediumClick?: boolean
  disableHover?: boolean
}

export default function ButtonAnimate({
  mediumClick = false,
  disableHover = false,
  children,
  sx,
  ...other
}: ButtonAnimateProps) {
  return (
    <Box
      component={motion.div}
      whileTap="tap"
      whileHover={disableHover ? 'none' : 'hover'}
      variants={mediumClick ? varMediumClick : varSmallClick}
      sx={{ display: 'inline-flex', ...sx }}
      {...other}
    >
      {children}
    </Box>
  )
}
